import * as React from "react";

function SvgBags(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path d="M13.603 3.83V.85H6.397v2.98H0v15.32h20V3.83h-6.397zM7.57 2.022h4.862V3.83H7.57V2.022zm11.26 15.956H1.171v-5.717a6.75 6.75 0 005.58 2.955h2.662v.969h1.172v-.969h2.662a6.75 6.75 0 005.58-2.954v5.716zm-7.56-3.934H8.73v-1.087h2.54v1.087zm1.98 0h-.807v-2.259H7.558v2.26h-.806a5.586 5.586 0 01-5.58-5.58V5.001h17.656v3.462a5.586 5.586 0 01-5.58 5.58z" />
    </svg>
  );
}

export default SvgBags;
